export default __webpack_public_path__ + "img/logo_store.d6811f2a.svg";